// extracted by mini-css-extract-plugin
export default {"testimonials":"style_testimonials__QtBEw","left":"style_left__j8oIg","right":"style_right__Nij1-","arrows":"style_arrows__jQLPc"};